import "components/order/style/OrderDetail.css";

const OrderRequest = ({ payIndex, od_option }) => {
  return (
    <div className="wrap_frame">
      <div className="order-request-wrap">
        <div className="order-request">
          <span className="order-title-light">
            <b>요청</b>사항
          </span>
          <span className="order-title-light">
            <b className="request_underline1">가게사장</b>님 <b>부탁</b>드려요!
          </span>
          <input
            type="text"
            id="request-text"
            className="ceo-msg"
            placeholder="예) 맛있게 해주세요!"
          />

          <ul className="request-list">
            {/* <li>
            <input type="checkbox" id="request8" name="request8" />
            <label htmlFor="request8"></label>
            <span>다음에도 사용</span>
          </li> */}
          </ul>

          {od_option > 1 && (
            <>
              <span className="order-title-light">
                <b className="request_underline2">라이더</b>님 <b>부탁</b>
                드려요!
              </span>
              <input
                type="text"
                id="request-text"
                className="rider-msg"
                placeholder="예) 운전 조심하세요!"
              />
            </>
          )}
          <ul className="request-list">
            {/* <li>
            <input type="checkbox" id="request4" name="request4" />
            <label htmlFor="request4"></label>
            <span>다음에도 사용</span>
          </li> */}
            <li>
              <input
                type="checkbox"
                id={"request5" + payIndex}
                name={"request5" + payIndex}
                className="need-fork"
              />
              <label htmlFor={"request5" + payIndex}></label>
              <span>일회용 수저 포크 필요해요</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OrderRequest;
